module.exports = __webpack_public_path__ + "static/5-07165c24307cbc44a58988bd09e877f1.png";